import React, { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, Form, Space } from 'antd';
import { PermissionsList, Role } from '../../../models';
import { apiClient, apiErrorMessage, hasPermission } from '../../../utils';
import { UserContext } from '../../contexts';

export function RolePermissionsForm(props: { role?: Role }) {
  const { user } = useContext(UserContext);

  const [permissions, setPermissions] = useState<PermissionsList>();
  const [loading, setLoading] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setCanEdit(hasPermission(user, 'roles.edit'));
  }, [user]);

  useEffect(() => {
    apiClient
      .get('permissions')
      .then((response: any) => {
        setPermissions(response.data);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      });
  }, []);

  const onEditFinish = (values: any) => {
    setLoading(true);
    const body = {
      permissions: values.permissions,
    };
    apiClient
      .post(`roles/${props.role?.id}/permissions`, body)
      .then(() => {
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  return (
    <Form onFinish={onEditFinish} initialValues={{ permissions: props.role?.permissions.map(p => p.key) }}>
      {permissions && (
        <Form.Item name="permissions">
          <Checkbox.Group>
            {permissions.systemPermissions.map((sp, i) => {
              return (
                <div key={sp.key} style={{ paddingLeft: '2rem', marginTop: i === 0 ? 0 : '1rem' }}>
                  <h4>{sp.name}</h4>
                  <Space direction="vertical" style={{ paddingLeft: '2rem' }}>
                    {sp.permissions.map(p => {
                      return (
                        <Checkbox key={p.key} value={p.key} style={{ display: 'block' }} disabled={!canEdit}>
                          {p.name}
                        </Checkbox>
                      );
                    })}
                  </Space>
                </div>
              );
            })}
          </Checkbox.Group>
        </Form.Item>
      )}
      {canEdit && (
        <Form.Item wrapperCol={{ offset: 3 }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Kaydet
          </Button>
        </Form.Item>
      )}
    </Form>
  );
}
